import styled from 'styled-components';

export const LoadingNav = styled.div`
  padding: 12px 24px;
`;
export const Loader = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
